import {get} from "../util/http.service";

export const getPortfolioHistory = () => get("/portfolio/history");
